module.exports = __webpack_public_path__ + "static/media/icon-pencil.77fb0991.svg";